import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Breadcrumb() {
  const { t } = useTranslation();
  const appContext = process.env.REACT_APP_CONTEXT_PATH;
  const findModulePath = (path: string) => {
    return `/${appContext}/${path}`;
  };
  return (
    <div>
      {" "}
      <Typography
        variant="h6"
        noWrap
        component="div"
        className="app-tittle app-tittle-div"
      >
        {window.location.pathname === findModulePath("dashboard") ||
        window.location.pathname === findModulePath("dashboardHO") ? (
          <b> Dashboard</b>
        ) : window.location.pathname === findModulePath("batch-list") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Batch</div>
          </div>
        ) : window.location.pathname === findModulePath("user-role") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">User Role</div>
          </div>
        ) : window.location.pathname === findModulePath("role-access") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Role Access</div>
          </div>
        ) : window.location.pathname === findModulePath("franchisee-master") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Franchisee Master</div>
          </div>
        ) : window.location.pathname === findModulePath("item-master") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Item Master</div>
          </div>
        ) : window.location.pathname === findModulePath("franchisee-group") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Franchisee Group</div>
          </div>
        ) : window.location.pathname === findModulePath("promo-code") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Promo Code</div>
          </div>
        ) : window.location.pathname === findModulePath("ho-feedback") ? (
          <div className="flex bolder">
            <div className="center">Settings</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Feedback</div>
          </div>
        ) : window.location.pathname === findModulePath("ho-admin-settings") ? (
          <div className="flex bolder">
            <div className="center">Settings</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Admin Settings</div>
          </div>
        ) : window.location.pathname === findModulePath("course-instructor") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Course Instructor</div>
          </div>
        ) : window.location.pathname === findModulePath("admin-user-master") ||
          window.location.pathname === findModulePath("user-master") ? (
          <div className="flex bolder">
            <div className="center">Master</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">User Master</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("student-lead-management") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">{t("studentLeadManagement")}</div>
          </div>
        ) : window.location.pathname === findModulePath("student-master") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Registration / Master</div>
          </div>
        ) : window.location.pathname === findModulePath("student-details") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">student details</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("student-attendance") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Student Attendance</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("certificate-booking-printing") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">
              {t("certificateBookingPrinting")}
            </div>
          </div>
        ) : window.location.pathname === findModulePath("student-invoice") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Invoice</div>
          </div>
        ) : window.location.pathname === findModulePath("payments-gateway") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Payment Gateway</div>
          </div>
        ) : window.location.pathname === findModulePath("payment-summary") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Payment Summary</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("student-redeem-point-order") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Redeem Point Order</div>
          </div>
        ) : window.location.pathname ===
            findModulePath("dispatch-redeemed-product") ||
          window.location.pathname ===
            findModulePath("ho-dispatch-redeemed-product") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Dispatch Redeemed Product</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("dispatch-purchase-order") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Dispatch Purchase Order</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("certificate-request") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Certificate Request</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("payment-gateway-settlement") ? (
          <div className="flex bolder">
            <div className="center">Student</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Payment Gateway Settlement</div>
          </div>
        ) : window.location.pathname === findModulePath("outstanding") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Outstanding</div>
          </div>
        ) : window.location.pathname === findModulePath("order") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Order</div>
          </div>
        ) : window.location.pathname === findModulePath("kit-outstanding") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Outstanding</div>
          </div>
        ) : window.location.pathname === findModulePath("sms-order") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">SMS Order</div>
          </div>
        ) : window.location.pathname === findModulePath("customer-discount") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Customer Discount</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("internal-purchase-order") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Internal Purchase Order</div>
          </div>
        ) : window.location.pathname === findModulePath("purchase-return") ||
          window.location.pathname === findModulePath("ho-purchase-return") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Purchase Return</div>
          </div>
        ) : window.location.pathname === findModulePath("payment") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Payment</div>
          </div>
        ) : window.location.pathname ===
          findModulePath("redeem-point-order") ? (
          <div className="flex bolder">
            <div className="center">Purchase</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Redeem Point Order</div>
          </div>
        ) : window.location.pathname === findModulePath("manage-reports") ||
          window.location.pathname === findModulePath("ho-manage-reports") ? (
          <div className="flex bolder">
            <div className="center">Report</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Manage Reports</div>
          </div>
        ) : window.location.pathname === findModulePath("send-email-sms") ? (
          <div className="flex bolder">
            <div className="center">{t("notification")}</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec"> {t("sendEmailSMS")}</div>
          </div>
        ) : window.location.pathname === findModulePath("template") ? (
          <div className="flex bolder">
            <div className="center">Notification</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Template</div>
          </div>
        ) : window.location.pathname === findModulePath("sent-history") ? (
          <div className="flex bolder">
            <div className="center">Notification</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Sent History</div>
          </div>
        ) : window.location.pathname === findModulePath("send-notification") ? (
          <div className="flex bolder">
            <div className="center">Notification</div>
            <div className="center">
              <ChevronRightIcon />
            </div>
            <div className="center color-sec">Send Notification</div>
          </div>
        ) : window.location.pathname === findModulePath("change-password") ? (
          <div className="flex bolder">
            <div className="center">Change Password</div>
          </div>
        ) : window.location.pathname === findModulePath("my-profile") ? (
          <div className="flex bolder">
            <div className="center">My Profile</div>
          </div>
        ) : null}
      </Typography>
    </div>
  );
}
